export const JEEmockFaq = [
    {
        targetId: '1',
        heading: '1. What is the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: 'Aakash JEE Advanced 2025 Mock Test Series is a series of online practice tests designed to help JEE 2025 aspirants assess their preparation. It follows the actual JEE Advanced exam pattern, covering Physics, Chemistry and Mathematics and provides performance analysis to help students understand their performance and preparation levels.',
    },
    {
        targetId: '2',
        heading: '2. Who can participate in the JEE Advanced 2025 Mock Test Series? What is the eligibility?',
        bulletpoints: [],
        subheading: 'Any JEE 2025 aspirant can register and appear for the mock tests. However, current Aakash students (Aakashians) are not eligible for this test series.',
    },
    {
        targetId: '3',
        heading: '3. How can I register for the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: 'Students can register online on https://jee-mocktest.aakash.ac.in/jee-mock-test. After filling in the required details and completing the registration process, they will receive exam-related communications.',
    },
    {
        targetId: '4',
        heading: '4. Will the JEE Advanced 2025 Mock Test Series be conducted Online or Offline?',
        bulletpoints: [],
        subheading: 'The JEE Advanced 2025 Mock Test Series will be conducted online. Students can appear for the tests online from anywhere.',
    },
    {
        targetId: '5',
        heading: '5. Is there any registration fee for the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: 'The fee for JEE Advanced 2025 Mock Test Series is ₹1200.',
    },
    {
        targetId: '6',
        heading: '6. What is the exam date and time slot for the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: '<table style="border:1px solid #ddd"><tr><td colspan="2" style="padding:9px 10px;text-align:center;background:#ddd">JEE Advanced 2025 Mock Test Series</td></tr><tr style="border-bottom: 1px solid #ddd;line-height: 15px;"><td style="padding:9px 10px;    border-right: 1px solid #ddd;">Test Mode</td><td style="padding:9px 10px">Test Mode Online</td></tr><tr style="border-bottom: 1px solid #ddd;line-height: 15px;"><td style="padding:9px 10px; border-right: 1px solid #ddd;" rowspan="2">Exam Duration / Exam Window</td><td style="padding:9px 10px">Paper 1:- 3 hr</td></tr><tr style="border-bottom: 1px solid #ddd;line-height: 15px;"><td style="padding:9px 10px;    border-right: 1px solid #ddd;">Paper 2:- 3 hr</td></tr><tr style="border-bottom: 1px solid #ddd;line-height: 15px;"><td style="padding:9px 10px; border-right: 1px solid #ddd;">Exam Window</td><td style="padding:9px 10px">Starting time 9 AM till next 48 hours</td></tr><tr style="border-bottom: 1px solid #ddd;line-height: 15px;"><td style="padding:9px 10px;border-right: 1px solid #ddd;">Last Date/Time for Enrollment</td><td style="padding:9px 10px">5 Days before the Exam Dates</td></tr><tr style="border-bottom: 1px solid #ddd;line-height: 15px;"><td style="padding:9px 10px;  border-right: 1px solid #ddd;">Registration Process</td><td style="padding:9px 10px">Online through a new landing page.</td></tr><tr style="border-bottom: 1px solid #ddd;line-height: 15px;"><td style="padding:9px 10px;border-right: 1px solid #ddd;">Result Declaration</td><td style="padding:9px 10px"> 3 days after exam date</td></tr></table>',
    },
    {
        targetId: '7',
        heading: '7.	What are the dates for the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: 'The test series exam dates are <strong>29th April and 2nd, 6th, 9th, 13th & 15th May 2025 </strong>',
    },
    {
        targetId: '8',
        heading: '8.	What are the timings for the mock tests?',
        bulletpoints: [],
        subheading: 'The mock test will start at 09:00 AM on the exam date and remain valid for the next 48 hours only.',
    },
    {
        targetId: '9',
        heading: '9.	What is the format of the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: 'Every mock test will have two papers: Paper 1 and Paper 2 with a duration of 3 hours each. Once active/unlocked, both the Papers (Paper 1 and Paper 2) need to be completed within the 48-hour window. You will not be able to start or attempt a mock test after the 48-hour window is over.',
    },
    {
        targetId: '10',
        heading: '10.	When will the result be declared for the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: 'The result will be announced 3 days after the exam date.',
    },
    {
        targetId: '11',
        heading: '11.	What are the benefits of the JEE Advanced 2025 Mock Test Series?',
        bulletpoints: [],
        subheading: '<ul><li>• Experience a real JEE Advanced-like exam environment.</li><li>• Identify strengths and weaknesses in Physics, Chemistry and Mathematics.</li><li>• Receive detailed performance analysis to refine your strategy.</li><li>• Practice with sample test papers before the final exam</li><li>• Get answer key and analysis right after the test</li></ul>',
    },
]
